import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Companies } from '../models/merchant.model';

export const MerchantData = createAction('[Merchant: Search]: Merchant Data');

export const CompanyNamesSuccess = createAction(
  '[Merchant: Search]: Company Names Success',
  props<{ res: Companies[] }>(),
);

export const CompanyNamesFailed = createAction(
  '[Merchant: Search]: Company Names Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const SubscriptionPlansSuccess = createAction(
  '[Merchant: Search]: SubscriptionPlans Success',
  props<{ res: any }>(),
);

export const SubscriptionPlansFailed = createAction(
  '[Merchant: Search]: SubscriptionPlans Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const SearchPanelStatusChanged = createAction('[Merchant: Search]: Search Panel StatusChanged');

export const CompanyNameChanged = createAction(
  '[Merchant: Search]: Company Name Changed',
  props<{ companyName: string }>(),
);

export const SubscriptionPlanChanged = createAction(
  '[Merchant: Search]: Subscription Plan Changed',
  props<{ subscriptionPlan: string }>(),
);

export const RegistrationDateFromChanged = createAction(
  '[Merchant: Search]: Registration Date From Changed',
  props<{ registrationDateFrom: Date; registrationDateFromText: string }>(),
);

export const RegistrationDateFromCleared = createAction('[Merchant: Search]: Registration Date From Cleared');

export const QivosIDChanged = createAction('[Merchant: Search]: Qivos ID Changed', props<{ qivosID: string }>());

export const VATNumberChanged = createAction('[Merchant: Search]: VAT Number Changed', props<{ vatNumber: string }>());

export const MemberStatusChanged = createAction('[Merchant: Search]: Member Status Changed');

export const ClearMerchantSearchOptions = createAction('[Merchant: Search]: Clear Search Options');

export const MerchantPageChanged = createAction('[Merchant: Search]: Page Changed');
